export const priceOptions = [
  {
    display: '1 ล้านบาท',
    urlParam: '1ล้าน',
    price: 1000000,
  },
  {
    display: '2 ล้านบาท',
    urlParam: '2ล้าน',
    price: 2000000,
  },
  {
    display: '3 ล้านบาท',
    urlParam: '3ล้าน',
    price: 3000000,
  },
  {
    display: '5 ล้านบาท',
    urlParam: '5ล้าน',
    price: 5000000,
  },
  {
    display: '7 ล้านบาท',
    urlParam: '7ล้าน',
    price: 7000000,
  },
  {
    display: '10 ล้านบาท',
    urlParam: '10ล้าน',
    price: 10000000,
  },
  {
    display: '15 ล้านบาท',
    urlParam: '15ล้าน',
    price: 15000000,
  },
  {
    display: '30 ล้านบาท',
    urlParam: '30ล้าน',
    price: 30000000,
  },
] as const;

// For url that only have min-price
export const minPriceUrlPrefix = 'ราคาต่ำสุด';
// For url that only have max-price
export const maxPriceUrlPrefix = 'ราคาสูงสุด';

export function getPriceByQuery(query: string): number {
  return priceOptions.find((option) => option.urlParam === query)?.price;
}

export function getQueryByPrice(price: number): string {
  return priceOptions.find((option) => option.price === price)?.urlParam;
}

export function getDisplayPriceByPrice(price: number): string {
  return priceOptions.find((option) => option.price === price)?.display;
}
